import { Helmet } from "react-helmet";
import CourseSection from "../Components/CourseSection";
import FormationCard from "../Components/FormationCard";
import Header from "../Components/Header";
import NavigationComp from "../Components/NavigationComp";
import SelectButton from "../Components/SelectButton";
import Forma from "../Pages/image/Formation.jpg"

const GetAllFormaView = (incendie, secourisme, prevention, loading) => {
    return (
        <>
            <Helmet>
                <title>Formations</title>
                <meta name="description" content="Toutes les formations" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <Header title="FORMATIONS" image={Forma} />
            <main className="main-content">
                <div className="course-filter">
                    {
                        secourisme == null && prevention == null ? (
                            <SelectButton option="incendie" />
                        ) : incendie == null && prevention == null ? (
                            <SelectButton option={"secourisme"} />
                        ) : incendie == null && secourisme == null ? (
                            <SelectButton option={"prevention"} />
                        ) : <SelectButton option={""} />
                    }


                </div>
                {incendie ? (
                    <CourseSection
                        title="Incendie"
                        description="<em> Prévenir le risque, protéger les personnes et préserver l’activité.</em> <br> En tant qu’employeur, vous avez l’obligation de permettre une réaction rapide et efficace en cas d’incendie. Nos formations incendie vous accompagnent dans cette démarche, en assurant la mise en conformité de vos équipes tout en protégeant votre outil de travail, vos salariés… et votre patrimoine."
                        courses={incendie}
                        colorClass="incendie"
                        loading={loading}
                    />
                ) : null}
                {secourisme ? (
                    <CourseSection
                        title="Secourisme"
                        description="<em>Parce que chaque seconde peut sauver une vie.</em> <br> Connaissez-vous les bons réflexes face à une urgence vitale ? Les gestes de premiers secours sont simples, mais essentiels. Nos formations en secourisme sont conçues pour vous transmettre des compétences pratiques, à jour, adaptées aux situations du quotidien comme aux cas les plus critiques. Avec SCFPS, devenez acteur de la chaîne des secours."
                        courses={secourisme}
                        colorClass="secourisme"
                        loading={loading}
                    />
                ) : null}
                {prevention ? (
                    <CourseSection
                        title="Prévention des risques"
                        description="<em>Anticiper les risques, c’est investir dans la performance et la sécurité.</em> <br> Former vos collaborateurs à la prévention des risques professionnels, c’est répondre à vos obligations légales, réduire les accidents et renforcer les compétences internes. Chez SCFPS, nous vous proposons des formations ciblées, adaptées à vos métiers, vos contraintes et vos enjeux."
                        courses={prevention}
                        colorClass="prevention"
                        loading={loading}
                    />
                ) : null}



            </main>
        </>

    )
}

export default GetAllFormaView;